import React from 'react';
import PropTypes from 'prop-types';

import styles from './MenuItem.css';

const IPropTypes = {
  className: PropTypes.string,
  menu: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  selected: PropTypes.bool.isRequired,
};

const defaultProps = {
  className: '',
  onClick: () => {},
  onFocus: () => {},
  onMouseEnter: () => {},
};

const generateCallback = (itemId, callback) => (event) => {
  event.stopPropagation();
  callback(itemId);
};

const MenuItem = (props) => {
  const selectedClass = props.selected ? styles.selected : '';
  return (
    <button
      className={[props.className, styles.container, selectedClass].join(' ')}
      onClick={generateCallback(props.menu.id, props.onClick)}
      onFocus={generateCallback(props.menu.id, props.onFocus)}
      onMouseOver={generateCallback(props.menu.id, props.onMouseEnter)}
    >
      {props.menu.name}
    </button>
  );
};

MenuItem.propTypes = IPropTypes;
MenuItem.defaultProps = defaultProps;

export { MenuItem };



// WEBPACK FOOTER //
// ./src/common/home-navbar/menu-item/MenuItem.jsx